import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import { useLoginWithGoogleMutation } from "../../services/authApi";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setCredentials } from "../../features/authSlice";
import { loginRedirectLogic } from "../../pages/AuthPages/Login";

const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;

export const GoogleLoginButton = () => {
  const [loginWithGoogle] = useLoginWithGoogleMutation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSuccess = async (response: { credential?: string }) => {
    const accessToken = response.credential;
    if (!accessToken) {
      console.error("Access token not found in Google response");
      toast.error("Google login failed. Please try again.");
      return;
    }

    try {
      const userData = await loginWithGoogle(accessToken).unwrap();

      dispatch(
        setCredentials({
          user: userData.user,
          token: userData.access,
        })
      );

      loginRedirectLogic(navigate, userData);
      toast.success("Logged in successfully!");
    } catch (err: unknown) {
      console.error("Login with Google error:", err);
      const errorMessage =
        typeof err === "object" &&
        err !== null &&
        "data" in err &&
        typeof (err as any).data?.message === "string"
          ? (err as any).data.message
          : "Google login failed. Please try again.";
      toast.error(errorMessage);
    }
  };

  const handleError = () => {
    console.error("Google login error");
    toast.error("Google login failed. Please try again.");
  };

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <GoogleLogin
        onSuccess={handleSuccess}
        onError={handleError}
        width="100%"
        logo_alignment="center"
      />
      <div
        onLoad={() => {
          if (window.google?.accounts?.id) window.google.accounts.id.prompt();
        }}
      ></div>
    </GoogleOAuthProvider>
  );
};
